import React from 'react';
import PropTypes from 'prop-types';
import { showWhenPermission } from '@/shared/components/security';
import RegistrationsPerReport from './RegistrationsPerReport';

const RegistrationsPerUserContainer = ({ searchParams }) => (
  <RegistrationsPerReport
    externalParams={searchParams}
    reportType={7}
    reportKey="RegsPerUserReport"
  />
);
RegistrationsPerUserContainer.propTypes = {
  searchParams: PropTypes.shape({}),
};

RegistrationsPerUserContainer.defaultProps = {
  searchParams: {},
};
export default showWhenPermission('RegistrationOwn', 'read')(RegistrationsPerUserContainer);
